import React from 'react';
import { makeStyles } from '@material-ui/core';

import classnames from 'classnames';

const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      position: 'relative',
      display: 'flex'
    },
    input: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '3rem',
      height: '1.5rem',
      opacity: 0,
      cursor: 'pointer'
    },
    box: {
      width: '1.5rem',
      height: '1.5rem',
      borderRadius: '4px',
      backgroundColor: '#CECCCC',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    active: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    }
  };
});

const SwitchPoundPercantage = ({ input, className }: any) => {
  const classes = useStyles();
  const isActivePounds = input.value;
  return (
    <div className={classnames(classes.container, className && className)}>
      <input
        className={classes.input}
        type="checkbox"
        defaultChecked={input.value}
        {...input}
      />
      <div
        className={classnames(classes.box, !isActivePounds && classes.active)}
        style={{
          borderRadius: '25px 0 0 25px'
        }}
      >
        £
      </div>
      <div
        className={classnames(classes.box, isActivePounds && classes.active)}
        style={{
          borderRadius: '0 25px 25px 0'
        }}
      >
        %
      </div>
    </div>
  );
};

export default SwitchPoundPercantage;
